'use client';

import { Column } from '@/components/container/Container';
import Spacing from '@/components/container/Spacing';
import QuestionsSection from '../components/QuestionsSection';
import TravelProgramHeader from '../components/TravelProgramHeader';
import YourProgramsSection from '../components/YourProgramsSection';

const TravelProgramScreen = () => {
	// const [visible, setVisible] = useState(false);

	return (
		<Column gap="gap-6">
			<TravelProgramHeader />
			<YourProgramsSection />
			<QuestionsSection />
			{/* <TravelCustomization visible={visible} setVisible={setVisible} /> */}
			{/* //TODO: below can be removed */}
			<Spacing height="h-4" />
		</Column>
	);
};

export default TravelProgramScreen;
